import { render } from "./PromotionPopup.vue?vue&type=template&id=10c94226&scoped=true"
import script from "./PromotionPopup.vue?vue&type=script&lang=js"
export * from "./PromotionPopup.vue?vue&type=script&lang=js"

import "./PromotionPopup.vue?vue&type=style&index=0&id=10c94226&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c94226"]])

export default __exports__